import React from 'react';

import { UpdatedField } from '../../typescript-types/employee-change-log';

import { EmployeeHistoryAssociationDetail } from './employee-history-association-detail';

type InputProps = {
  changeHistoryId: number;
  groupChanges?: UpdatedField<Array<number>>;
  employeeGroups: Array<EmployeeGroup>;
};

export const EmployeeHistoryEmployeeGroupDetail = ({
  changeHistoryId,
  groupChanges,
  employeeGroups,
}: InputProps) => {
  const getGroupDetailById = (groupId: number) =>
    employeeGroups.find((group) => group.employeeGroupId === groupId)?.name || '';

  return (
    <EmployeeHistoryAssociationDetail
      changeHistoryId={changeHistoryId}
      newValue={groupChanges?.newValue || []}
      oldValue={groupChanges?.oldValue || []}
      associationLabel="group"
      getAssociationNameById={getGroupDetailById}
    />
  );
};
